import { render, staticRenderFns } from "./LanguageSave.vue?vue&type=template&id=e7cc5210&scoped=true"
import script from "./LanguageSave.vue?vue&type=script&lang=js"
export * from "./LanguageSave.vue?vue&type=script&lang=js"
import style0 from "./LanguageSave.vue?vue&type=style&index=0&id=e7cc5210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7cc5210",
  null
  
)

export default component.exports